import { Injectable } from '@angular/core';
/* eslint-disable */
declare let Froged: Function;

@Injectable({
  providedIn: 'root',
})
export class FrogedEventService {
  emitEvent(eventName: string, params) {
    Froged('track', eventName, params);
  }

  logout() {
    Froged('logout');
  }
  set(params) {
    Froged('set', params);
  }
}
